<template>
    <div style="min-width: 850px;">
        <!-- 设备类型 -->
        <div style="margin-bottom:20px;display:flex;align-items:center;justify-content:space-between;">
            <div class="form-title" style="margin-bottom:0;">设备类型</div>
            <el-button type="primary" size="small" @click="addDevice">新增设备</el-button>
        </div>
        <!-- 循环设备Tag -->
        <div class="custom-attr" v-for="(dItem,dIndex) in equipmentsOffline" :key="dIndex">
            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;justify-content: space-between;">
                    <el-form-item label="设备名称" style="margin-bottom: 0;">
                        <el-input v-model="dItem.equipmentName" size="small" style="width: 70%;" disabled placeholder="请选择设备"></el-input>
                        <el-button type="primary" size="small" @click="selectDevice(dItem)">选择设备</el-button>
                    </el-form-item>
                </div>
                <div>
                    <div v-if="dIndex!=0" class="close-icon" @click="delDevice(dIndex)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <!-- 选择设备类型 -->
            <el-drawer
                title=""
                :with-header="false"
                :visible.sync="dItem.drawer"
                direction="rtl"
                size="1000px">
                <div class="drawer-title">选择设备类型</div>
                <div class="drawer-content">
                    <div class="table-tree">
                        <div class="tree">
                            <div class="tree-title">
                                <div>
                                    <i class="el-icon-share" style="margin-right:10px;"></i>设备类型
                                </div>
                            </div>
                            <div class="tree-park" v-for="(item,index) in supplierData" :key="index">
                                <div class="park-title" :class="current==item.equipmentBrandCode?'bright':''" @click.prevent="brandToggle(item.equipmentBrandCode)">
                                <span class="class-icon iconfont icon-xiangmu" :style="current==item.equipmentBrandCode?'color:#FFF;':'color:#3498db;'"></span>
                                <span>{{item.equipmentBrand}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="table">
                            <el-table :data="tableData" style="width: 99%" height="700" v-loading="tableLoading" element-loading-spinner="el-icon-loading">
                                <el-table-column label="勾选" width="70">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="dItem.configRadio" @change="checkConfig(scope.row,dItem)">
                                            <el-radio :label="scope.row.eid">{{''}}</el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="waterworks" label="水厂">
                                    <template slot-scope="scope">
                                    {{ scope.row.waterworks?scope.row.waterworks:'-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="position" label="泵房编号">
                                    <template slot-scope="scope">
                                    {{ scope.row.position?scope.row.position:'-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="equipmentName" label="设备名称">
                                    <template slot-scope="scope">
                                    {{scope.row.equipmentName?scope.row.equipmentName:'-'}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="eid" label="设备号"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="drawer-bottom">
                    <el-button size="small" type="primary" @click="dItem.drawer=false">取消</el-button>
                    <el-button size="small" type="primary" @click="drawerOK(dItem)" class="drawer-bottom-ok">确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            supplierData: [],
            tableData: [],
            treeLoading: false,
            tableLoading: false,
            abilityLoading: false,
            current: null,
            selectCache: {},
            selectConfigObj: {},
            dataType: ['Bool','Real'],
            equipmentsOffline: this.equipmentsOfflines,

            tagTableData: []
        }
    },
    props: {
        equipmentsOfflines: {
            type: Array
        },
        resource: {
            type: String
        }
    },
    methods: {
        // 新增设备
        addDevice() {
            this.equipmentsOffline.push({
                drawer: false,
                configRadio: '',
                gatewayEid:null,
                eid:null,
                equipmentBrandCode: null,
                equipmentName: null
            })
            this.$forceUpdate()
        },
        // 删除设备
        delDevice(index) {
            this.equipmentsOffline.splice(index,1)
        },
        // 选择设备项目
        selectDevice(dItem) {
            dItem.drawer = true
            if(dItem.equipmentBrandCode) {
                this.current = dItem.equipmentBrandCode
                this.loadListData()
            }
            this.selectCache.gatewayEid = dItem.gatewayEid
            this.selectCache.eid = dItem.eid
            this.selectCache.equipmentName = dItem.equipmentName
            this.selectCache.equipmentBrandCode = dItem.equipmentBrandCode
        },
        // 勾选设备项目
        checkConfig(row,dItem) {
            this.selectCache = {}
            dItem.configRadio = row.eid
            this.selectCache = row
        },
        // 确认选择设备项目
        drawerOK(dItem) {
            if(dItem.equipmentBrandCode!=this.selectCache.equipmentBrandCode) {
                dItem.gatewayEid = null
                dItem.eid = null
                dItem.equipmentName = null
                dItem.equipmentBrandCode = null
            }
            dItem.gatewayEid = this.selectCache.gatewayEid
            dItem.eid = this.selectCache.eid
            dItem.equipmentName = this.selectCache.equipmentName
            dItem.equipmentBrandCode = this.selectCache.equipmentBrandCode
            this.selectConfigObj = this.selectCache
            dItem.drawer = false
        },
        // 获取设备
        loadListData() {
            this.tableLoading = true
            this.$ajax.post('equipmentByEcode',{
                pageNum: 0,
                pageSize: 0,
                equipmentBrandCode: this.current,
            }).then(res => {
                res.data.forEach(v=>{
                    v.check = false
                })
                this.tableData = res.data
                this.tableLoading = false
            }).catch(err=>{
                this.tableLoading = false
            })
        },
        // 切换设备项目
        brandToggle(equipmentBrandCode) {
            this.current = equipmentBrandCode
            this.equipmentBrandCode = equipmentBrandCode
            sessionStorage.setItem('equipmentBrandCode',equipmentBrandCode)
            this.loadListData()
        },
        // 获取品牌
        loadBrand() {
            this.treeLoading = true
            this.$ajax.post('equipmentGroupQuery',{
                deviceTypeCodes: ['GatewaySub']
            }).then(res => {
                if(res.data.length==0) {
                    this.treeLoading = false
                }
                this.supplierData = res.data
                if(sessionStorage.getItem('equipmentBrandCode')){
                    this.current = sessionStorage.getItem('equipmentBrandCode')
                    this.equipmentBrandCode = sessionStorage.getItem('equipmentBrandCode')
                    this.loadListData()
                }else{
                    this.current = this.supplierData[0].equipmentBrandCode
                    this.equipmentBrandCode = this.supplierData[0].equipmentBrandCode
                    this.loadListData()
                }
                this.treeLoading = false
            }).catch(err=>{
                this.treeLoading = false
            })
        },
        // 获取Tag列表
        loadTagsList(eid) {
            this.abilityLoading = true
            this.$ajax.post("iotTagsQuery", {}, { 
                eid
            }).then(res=>{
                this.tagTableData = res.data
                this.abilityLoading = false
            }).catch(err=>{
                this.abilityLoading = false
            })
        }
    },
    mounted() {
        if(this.resource=='add') {
            sessionStorage.removeItem('equipmentBrandCode')
            this.loadBrand()
        }
        if(this.resource=='edit') {
            sessionStorage.setItem('equipmentBrandCode',this.current) 
            // this.selectConfigObj.equipmentBrandCode = this.equipmentsOffline.eid
            // this.configRadio = this.equipmentsOffline.eid
            this.loadBrand()
        }
        this.$forceUpdate()
    }
}
</script>
<style lang="less" scoped>
.table-tree {
  display: flex;
  height: ~'calc(100% - 56px)';
  .tree {
    min-width: 300px;
    border-right: 4px solid #f6f7fb;
    margin-right: 20px;
  }
  .table {
    flex: 1;
  }
  .operate {
    &:hover {
      color: #409EFF;
    }
  }
  .custom-tree-node {
    font-size: 14px;
  }
}
/deep/.el-drawer__body {
    height: 100%;
    margin-bottom: 50px;
}
.drawer-content {
    margin: 10px 0;
    height: 86%;
    overflow-y: auto;
}
.tree-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tree-park {
  font-size: 14px;
  cursor: pointer;
}
.park-title {
  line-height: 35px;
  padding-left: 20px;
}
.class-icon {
  display: inline-block;
  margin-right: 8px;
}
.bright {
  background: #409EFF;
  color: #FFF;
  border-radius: 5px;
}
.custom-attr {
  border: 1px solid #ebeef5;
//   box-shadow: 0px 0px 10px rgba(211, 211, 211, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 20px;
  .close-icon {
    width: 25px;
    background-color: #ff7979;
    color: #FFF;
    text-align: center;
    line-height: 25px;
    border-radius: 5px;
    cursor: pointer;
    transition: all .3s ease;
    margin-top: 8px;
    &:hover {
        background-color: rgba(255, 121, 121, .7);
    }
  }
}
.el-select {
    width: 100%;
}
.formula-type {
    display: flex;
    align-items: center;
}
.formula-left {
    background-color: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    color: #409eff;
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 14px;
}
.f-symbol {
    font-size: 14px;
    text-align: center;
    background: #f2f2f2;
    border-radius: 5px;
    width: 30px;
    line-height: 30px;
    margin: 0 20px;
    color: #333;
}
.tag-explain {
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin:20px 0px;
}
.tag-explain-title {
  font-size:14px;
  margin-left:40px;
  font-weight:bold;
}
.close-lube-btn {
  display: inline-block;
  text-align: center;
  width: 100%;
  color: #409EFF;
  line-height: 32px;
  border-radius: 4px;
  background: #ecf5ff;
  border-color: #409EFF;
  .close-lube {
    cursor: pointer;
  }
}
</style>